import type { Board } from "../board";
import { CircleEffect } from "../effects/circleEffect";
import { PRIORITY_DEFAULT, type ProcessableThing, type ProjectileHittable } from "../interfaces";
import { PhysicalThingWithHp, STD_BASE_HP } from "../physicalThingWithHp";
import { randomInt } from "../random";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { ZOrder } from "../zOrder";

export class Spreader extends PhysicalThingWithHp implements ProjectileHittable, ProcessableThing {
	static key = "Spreader";
	private timeSinceLastMove: number;
	static readonly moveEveryXTurns = 20;

	constructor(xy: XY) {
		super(xy, true);
		this.hp = STD_BASE_HP;
		this.maxHp = STD_BASE_HP;
		this.timeSinceLastMove = randomInt(0, Spreader.moveEveryXTurns - 1);
	}

	getZOrder(): number {
		return ZOrder.SCENARIO;
	}

	onProjectileHit(_projectile: unknown): void {}

	isHittable(): boolean {
		return true;
	}

	processTurn(board: Board): void {
		this.timeSinceLastMove++;
		if (this.timeSinceLastMove < Spreader.moveEveryXTurns) return;
		this.timeSinceLastMove = 0;

		for (const neighborXY of board.getNeighbors(this.xy)) {
			if (!board.isPassable(neighborXY)) continue;
			if (board.hasMob(neighborXY)) continue;

			let spreaderCount = 0;
			for (const adj of board.getNeighbors(neighborXY)) {
				for (const thing of board.getThingsAt(adj)) {
					if (thing instanceof Spreader && thing.active) spreaderCount++;
				}
			}

			if (spreaderCount >= 3) {
				board.addEffect(new CircleEffect(neighborXY));
				const newSpreader = new Spreader(neighborXY);
				board.addThing(newSpreader);
				return;
			}
		}
	}

	getProcessPriority(): number {
		return PRIORITY_DEFAULT;
	}

	serialize(): Record<string, unknown> {
		return { ...super.serialize(), timeSinceLastMove: this.timeSinceLastMove };
	}

	static deserialize(data: any): Spreader {
		const s = new Spreader(deserializeXY(data.xy));
		s.restoreBaseFields(data);
		s.timeSinceLastMove = data.timeSinceLastMove;
		return s;
	}
}
